import Color from "color";
import styled from "styled-components";

import { chooseBestContrast } from "../utils/colorContrast";
import { ApiRoute } from "../types";

const PinWrapper = styled.div`
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-style: solid;
  border-width: 2px;
  font-size: 9px;
  z-index: 1;
  font-weight: 700;
  width: 15px;
  height: 15px;

  &.selected {
    transform: scale(2) translateX(-25%) translateY(-25%);
    z-index: 2;
    border-width: 1px;
  }

  > div:not(.indicator) {
    position: relative;
    z-index: 1;
  }

  > div.click {
    margin: -10px;
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .indicator.ticked {
    position: absolute;
    bottom: -2px;
    right: -3px;
    width: 6px;
    height: 6px;
    background: #52ff6e;
    border-radius: 8px;
  }
`;

const Pin = ({
  route,
  position,
  active,
  className,
  style,
  ticked,
  onClick,
}: {
  route: ApiRoute & { displayNumber?: number };
  position: [number, number];
  active: boolean;
  className?: string;
  ticked?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
  selectedCategoryUUID?: string;
}) => {
  const routeColor = route.colors?.split(":")?.[0] || "#FFFFFF";
  const transformStyle =
    position[0] && position[1]
      ? {
          transform: `translate(${position[0]}px, ${
            position[1]
          }px) translate(-50%, -50%) scale(${active ? 2 : 1})`,
        }
      : {
          transition: "transform 500ms ease-in-out",
        };
  return (
    <PinWrapper
      className={
        (className || "") + (active ? " route-pin selected" : " route-pin")
      }
      style={{
        left: 0,
        top: 0,
        position: "absolute",
        color: chooseBestContrast(routeColor, ["#fff", "#000"]),
        backgroundColor: routeColor,
        borderColor: Color(routeColor).darken(0.1).toString(),
        borderRadius: route.climbType === "SPORT" ? "5px" : "50%",
        ...transformStyle,
        ...style,
      }}
    >
      <div className="click" onClick={onClick} />
      <div>{route.displayNumber}</div>
      {ticked ? <div className="indicator ticked"></div> : null}
    </PinWrapper>
  );
};

export default Pin;
